export type RegulationItem =
  | string
  | Array<string | { text: string; url: string }>;

export interface RegulationSection {
  title: string;
  content: {
    subtitle?: string;
    items?: RegulationItem[];
  }[];
}

export interface RegulationTexts {
  title: string;
  sections: RegulationSection[];
}

export const regulationTexts: RegulationTexts = {
  title: 'RLP (Retail Liquidity Provider)',
  sections: [
    {
      title: '1. O que é a Oferta RLP',
      content: [
        {
          subtitle: 'a. Definição',
          items: [
            [
              'O investidor ao aderir à oferta RLP concorda que a sua corretora seja contraparte das ofertas agressoras nos minicontratos (WIN e WDO) e em tickers do mercado de ações (disponíveis ',
              {
                text: 'aqui',
                url: 'https://www.b3.com.br/pt_br/solucoes/plataformas/puma-trading-system/para-participantes-e-traders/regras-e-parametros-de-negociacao/oferta-retail-liquidity-provider-rlp/'
              },
              '), autorizando que as suas ofertas sejam atendidas por uma oferta oculta disponibilizada pela corretora e não sejam enviadas para o livro central de ofertas da B3.'
            ],
            'Neste tipo de oferta, o investidor determina a quantidade de compra ou venda do ativo e o preço é contínua e automaticamente ajustado pelo sistema de negociação da B3 (PUMA) para o melhor preço de compra ou de venda disponível naquele momento (oferta pegged). Caso a diferença entre o melhor preço de compra e o melhor preço de venda (spread) seja maior que 1 tick size, o preço será automaticamente melhorado.'
          ]
        },
        {
          subtitle: 'b. Dinâmica operacional',
          items: [
            'Todos os investidores pessoas naturais da corretora, que tiverem perfil de risco adequado, podem aderir às ofertas RLP e não é permitido que a corretora faça distinção entre os investidores desse tipo. Quando o investidor aderente ao RLP envia uma oferta, a sua corretora é contraparte da operação. Entretanto, caso haja oferta de outro investidor da mesma corretora no melhor preço do livro central da B3, esta tem prioridade frente à oferta da corretora.',
            'Caso o spread (diferença entre o melhor preço de compra e o melhor preço de venda) do livro central seja igual ou superior a 2 tick sizes, a corretora tem a obrigação de melhorar o preço de compra/venda em, ao menos, 1 tick size.',
            'Na oferta RLP, a corretora dá liquidez aos seus clientes ao atuar na contraparte das operações, ou seja, ao comprar e vender os ativos negociados pelos seus clientes. Dessa forma, a corretora pode ser contraparte do investidor nos negócios e obter ganhos com isso, proveniente da diferença entre o preço de compra e o preço de venda.'
          ]
        }
      ]
    },
    {
      title: '2. Riscos do day-trade',
      content: [
        {
          subtitle:
            'a. Day-trade é um tipo de operação em que o investidor realiza a abertura e o fechamento de posição (operações de compra e venda) no mesmo dia, e no mesmo intermediário. Ao atuar neste mercado, o investidor negocia contra outros tipos de investidores, como os institucionais e os de alta frequência, os quais possuem estratégias complexas e acesso à tecnologia altamente sofisticada.'
        },
        {
          subtitle:
            'b. É essencial considerar os custos operacionais (corretagem se existir, emolumentos etc.) na sua avaliação de resultado. Estes custos podem aumentar os prejuízos ou diminuir o lucro das operações.'
        },
        {
          subtitle:
            'c. Não é recomendado aos investidores com baixa tolerância ao risco atuar neste mercado. O investidor deve ter ciência de que pode perder o valor total dos recursos alocados.'
        },
        {
          subtitle:
            'd. Operações deste tipo podem resultar em grandes e rápidas perdas financeiras.'
        },
        {
          subtitle:
            'e. O investidor deve conhecer bem o funcionamento das operações de daytrade na corretora onde é cliente. É essencial entender o funcionamento dos limites, mecânica de envio de ordens, horários de funcionamento dos mercados e limites que podem resultar em zeragens compulsórias de posição. Dessa forma, o investidor pode evitar zeragens inesperadas e realizar o encerramento de suas posições para evitar ou reduzir prejuízos financeiros.'
        }
      ]
    },
    {
      title: '3. Gestão de risco',
      content: [
        {
          subtitle: 'a. Controle pelo investidor',
          items: [
            'Day-trade é um tipo de operação em que o investidor realiza a abertura e o fechamento de posição (operações de compra e venda) no mesmo dia e no mesmo intermediário. É essencial para o investidor que pretende atuar em operações de day-trade conhecer sobre ferramentas e métodos, como análise gráfica, métodos analíticos e sistemas que podem auxiliá-lo na realização dessas operações.',
            'Além disso, se faz igualmente importante o entendimento de como fatores externos podem impactar os resultados. Nesse sentido, o investidor deve compreender a relação entre fatores macroeconômicos (como taxa de juros, inflação, taxa de câmbio) e seus investimentos, bem como acompanhar os noticiários, a fim de ajustar suas posições de acordo com a expectativa gerada no mercado por estes eventos.',
            'Antes de iniciar um dia de operação, é importante que o investidor tenha clareza de seus objetivos e limites, isto é, tenha definido seu preço de entrada e alvo de saída, tanto para ganhos quanto para perdas. Essa definição antes do início da operação garante que o investidor não estará sujeito a vieses comportamentais em momentos de alta volatilidade, por exemplo.',
            'O uso de ofertas do tipo stop loss pode auxiliar o investidor nessa gestão, dado que este tipo de oferta permite automatizar o encerramento de uma operação ao atingir determinado nível de preço estabelecido inicialmente. Não deixe de parametrizar seus gatilhos de saída.'
          ]
        },
        {
          subtitle: 'b. Zeragem compulsória',
          items: [
            'A zeragem compulsória ocorre quando a corretora identifica que o investidor atingiu o limite máximo de perda permitido, segundo limite estabelecido pela própria corretora.',
            'Identificado o desenquadramento, a corretora poderá encerrar as posições do investidor a preço de mercado, o que, a depender dos preços naquele instante, pode resultar na realização de prejuízo financeiro.',
            'Além do prejuízo financeiro decorrente do resultado da operação, o investidor deve atentar-se aos valores de corretagem cobrados pela corretora para comandar zeragens deste tipo. Para zeragens comandadas pelo intermediário (zeragens compulsórias) poderá haver cobrança de um valor, calculado por contrato zerado. Os valores cobrados são divulgados por cada corretora.'
          ]
        }
      ]
    }
  ]
};
